import { getApiErrorMessage as getErrorMessageUtil } from '@/utils'
import axios from 'axios'
import { toast } from 'vue-sonner'

export async function useErrorHandling<T>(
    promise: Promise<T> | ((...args: unknown[]) => Promise<T>),
    getErrorMessage = getErrorMessageUtil,
) {
    try {
        if (typeof promise === 'function') return await promise()
        return await promise
    } catch (error: unknown) {
        const errorMessage = getErrorMessage(error)

        const suppressToast = axios.isAxiosError(error) && error.config?.suppressToast

        const isCancelled = axios.isAxiosError(error) && error.code === 'ERR_CANCELED'

        if (!suppressToast && !isCancelled) {
            toast.error(errorMessage || 'Network request failed')
        }

        throw error
    }
}
